'use strict';

var _extends = require('../../../@babel/runtime/helpers/esm/extends.cjs');
var React = require('react');
var index = require('../../react-primitive/dist/index.cjs');

const $7e8f5cd07187803e$export$21b07c8f274aebd5 = /*#__PURE__*/ React.forwardRef((props, forwardedRef)=>{
    const { children: children , width: width = 10 , height: height = 5 , ...arrowProps } = props;
    return /*#__PURE__*/ React.createElement(index.Primitive.svg, _extends({}, arrowProps, {
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none"
    }), props.asChild ? children : /*#__PURE__*/ React.createElement("polygon", {
        points: "0,0 30,0 15,10"
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $7e8f5cd07187803e$export$be92b6f5f03c0fe9 = $7e8f5cd07187803e$export$21b07c8f274aebd5;

exports.Arrow = $7e8f5cd07187803e$export$21b07c8f274aebd5;
exports.Root = $7e8f5cd07187803e$export$be92b6f5f03c0fe9;
//# sourceMappingURL=index.cjs.map
